import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-template-inca',
  templateUrl: './template-inca.component.html',
  styleUrls: ['./template-inca.component.scss']
})
export class TemplateIncaComponent implements OnInit {

  logoInca: string;


  constructor() { }

  ngOnInit(): void {
     this.logoInca= `${environment.caminhoLogoInca}`


  }


}
